module.exports = __webpack_public_path__ + "static/img/b4.604f903.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/b4.jpg
// module id = TDk2
// module chunks = 0